export enum PATHS {
  'HOME' = '/',
  'LOBBY' = '/lobby',
  'LOGIN' = '/login',
  'REGISTER' = '/register',
  'BONUSES' = '/bonuses',
  'PROMOTIONS' = '/promotions',
  'SPORTS' = '/sports',
  'SPORTSBOOK' = '/sportsbook',
  'CASHIER' = '/cashier',
  'RESTORE' = '/restore',
  'GAMES' = '/games',
  'LOYALTY' = '/loyalty',
  'WELCOME-OFFER' = '/promotions/welcome-offer',
  'UNIQUE-EXPERIENCE' = '/promotions/unique-experience',
  'DAILY-BONUS' = '/promotions/daily-bonus',
  'LIVE-CASINO' = '/promotions/live-casino',
  'ACCOUNT' = '/account',
  'ACCOUNT_UPDATE' = '/account/update',
  'ACCOUNT_VERIFY' = '/verifications/verification',
  'ACCOUNT_VERIFY_FEEDBACK' = '/verifications/verification/feedback',
  'ACCOUNT_SOF' = '/verifications/sof/upload',
  'ACCOUNT_SOFQ' = '/verifications/sof',
  'ACCOUNT_REMIND' = '/account/remind',
  'ACCOUNT_PROFILE' = '/account/profile',
  'ACCOUNT_ACCESS' = '/account/access',
  'ACCOUNT_CONTACT_INFO' = '/account/contact-info',
  'ACCOUNT_MORE_INFO' = '/account/more-info',
  'VERIFICATIONS' = '/verifications',
  'PAYMENTS_VERIFICATION' = '/verifications/verification/payments',
  'ACCOUNT_RESPONSIBLE_GAMING' = '/account/responsible-gaming',
  'DEPOSIT' = '/cashier/deposit',
  'DEPOSIT_SUCCESS' = '/cashier/deposit/success',
  'DEPOSIT_CANCEL' = '/cashier/deposit/cancel',
  'DEPOSIT_FAIL' = '/cashier/deposit/fail',
  'WITHDRAW' = '/cashier/withdraw',
  'WITHDRAW_SUCCESS' = '/cashier/withdraw/success',
  'WITHDRAW_FAIL' = '/cashier/withdraw/fail',
  'TRANSACTIONS' = '/cashier/history',
  'SUSPEND' = '/suspend',
  'ACCOUNT_NOTIFICATIONS' = '/account/notifications',
  'PLAY' = '/play/:id',
  'PLAY_FOR_FUN' = '/play-for-fun/:id',
  'ABOUT_US' = '/about-us',
  'CONTACT_US' = '/contact-us',
  'CONTACT_SUPPORT' = '/contact-us',
  'PAYMENT_METHODS' = '/payment-methods',
  'ACCOUNT_SUSPENDED' = '/status/break',
  'ACCOUNT_CLOSED' = '/status/freeze',
  'ACCOUNT_DISABLED' = '/status/disabled',
  'EMTA' = '/status/emta',
  'AGE_RESTRICT' = '/status/age',
  'NOT_FOUND' = '/status/not-found',
  'ACCOUNT_BLOCKED' = '/status/blocked',
  'SUPPORT' = '/support',
  'FAQ' = '/faq',
  'TERMS_PAGE' = '/page/terms-and-conditions',
  'PRIVACY_PAGE' = '/page/privacy-policy',
  'PNP_STATUS_SUCCESS' = '/paynplay/status/success',
  'PNP_STATUS_FAIL' = '/paynplay/status/fail',
  'PNP_STATUS_CANCEL' = '/paynplay/status/cancel',
  'PNP_STATUS' = '/paynplay/status',
  'AUDIT' = '/audit',
  'DENY' = '/deny',
  'WHEEL_BONUS' = '/wheel-bonus',
  'TOO_MANY_ATTEMPTS' = '/too-many-attempts',
}

export enum API {
  'REGISTER' = '/api/account/register',
  'LOGIN' = '/api/account/login',
  'LOGOUT' = '/api/account/logout',
  'SUSPEND' = '/api/account/suspend',
  'CLOSE' = '/api/account/close',
  'INFO' = '/api/account/info',
  'NOTIFICATIONS_SUBSCRIBE' = '/api/account/notifications/subscribe',
  'GAMES' = '/api/games',
}
